module.exports = __webpack_public_path__ + "img/store-inv.51986817.png";